import { useTranslation } from "react-i18next"
import { Button, Form, FormLabel, Row } from 'react-bootstrap'
import { Fragment, useEffect, useState } from "react"
import Select from "react-select"
import customStyles from "../../../components/design/select"
import { useDispatch, useSelector } from "react-redux"
import { addCardaux } from "../../../actions/cardsauxActions"
import { getFarms } from "../../../actions/farmsActions"
import { getPlots } from "../../../actions/plotsActions"
import { getCrops, getCropsByPlot } from "../../../actions/cropsActions"
import { getLabors } from "../../../actions/laborsActions"
import { getMachineries } from "../../../actions/machineriesActions"
import { getProducts } from '../../../actions/productsActions'
import Swal from "sweetalert2"
import moment from "moment-timezone"
import { useNavigate } from 'react-router-dom';

export default function FormCardaux({state}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {plots} = useSelector((state) => state.plots)
    const [plotOptions, setPlotsOptions] = useState({options: [], selected: null})

    const {crops} = useSelector((state) => state.crops)
    const [cropOptions, setCropsOptions] = useState({options: [], selected: null})

    const {labors} = useSelector((state) => state.labors)
    const [laborOptions, setLaborsOptions] = useState({options: [], selected: null})

    const {machineries} = useSelector((state) => state.machineries)
    const [machineryOptions, setMachineriesOptions] = useState({options: [], selected: null})

    const [dateinformat, setDateinformat] = useState(null)
    const [dateoutformat, setDateoutformat] = useState(null)

    const {products} = useSelector((state) => state.products)
    const [productOptions, setProductsOptions] = useState({options: [], selected: null})
    const [productsForResume, setProductsForResume] = useState([])
    const [productsExtraForResume, setProductsExtraForResume] = useState([])

    const [formState, setFormState] = useState({})
    const {idCard, user, datein, dateout} = formState

    const inputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const changeLitresGasoil = (target) => {
        setFormState({
            ...formState,
            litres_gasoil: target.target.value
        })
    }

    const changeLitresEngineOil = (target) => {
        setFormState({
            ...formState,
            litres_engine_oil: target.target.value
        })
    }

    const changeLitresHydraulicOil = (target) => {
        setFormState({
            ...formState,
            litres_hydraulic_oil: target.target.value
        })
    }

    const changeLitresUrea = (target) => {
        setFormState({
            ...formState,
            litres_urea: target.target.value
        })
    }

    const changeLitresGrease = (target) => {
        setFormState({
            ...formState,
            litres_grease: target.target.value
        })
    }

    const handleSubmit = async(e) => {
        e.preventDefault()

        let sendidCard = idCard
        let senduser = user
        let senddatein = datein
        let senddateout = dateout
        let sendplot = plotOptions?.selected?.value
        let sendcrop = cropOptions?.selected?.value
        let sendlabor = laborOptions?.selected?.value
        let sendmachinery = machineryOptions?.selected?.value
        let sendlitres_gasoil = parseInt(formState.litres_gasoil)
        let sendlitres_engine_oil = parseInt(formState.litres_engine_oil)
        let sendlitres_hydraulic_oil = parseInt(formState.litres_hydraulic_oil)
        let sendlitres_urea = parseInt(formState.litres_urea)
        let sendlitres_grease = parseInt(formState.litres_grease)

        let sendproducts = formState?.products?.map(product => {
            delete product.name
            return product
        })

        let sendproductsextra = formState.product_extra
        dispatch(addCardaux(sendidCard, senduser, senddatein, senddateout, sendplot, sendcrop, sendlabor, sendmachinery, sendlitres_gasoil, sendlitres_engine_oil, sendlitres_hydraulic_oil, sendlitres_urea, sendlitres_grease, sendproducts, sendproductsextra))

        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('cardaux.added')
        })
        navigate('/administrative/cards')
    }

    useEffect(()=>{
        dispatch(getFarms())
        dispatch(getPlots())
        dispatch(getCrops())
        dispatch(getLabors())
        dispatch(getMachineries())
        dispatch(getProducts())
    }, [dispatch, t])

    useEffect(()=>{
        if(state !== null){
            setFormState(state)
        }
    },[state])

    useEffect(()=>{
        if(formState){
            let plotsAvailable = []
            let plotsSelected
            let cropsAvailable = []
            let cropsSelected
            let laborsAvailable = []
            let laborsSelected
            let machineriesAvailable = []
            let machineriesSelected

            plots?.forEach(plot => {
                let object = {value: plot._id, label: plot.name}
                plotsAvailable.push(object)
                if(formState.plot){
                    if (formState.plot._id === plot._id) {
                        plotsSelected = plotsAvailable[plotsAvailable.length - 1]
                        dispatch(getCropsByPlot(plot._id))
                    }
                }
            })
            setPlotsOptions({options: plotsAvailable, selected: plotsSelected})
            
            crops?.forEach(crop => {
                let object = {value: crop._id, label: crop.name}
                cropsAvailable.push(object)
                if(formState.crop){
                    if (formState.crop._id === crop._id) {
                        cropsSelected = cropsAvailable[cropsAvailable.length - 1]
                    }
                }
            })
            setCropsOptions({options: cropsAvailable, selected: cropsSelected})

            labors?.forEach(labor => {
                let object = {value: labor._id, label: labor.name}
                laborsAvailable.push(object)
                if(formState.labor){
                    if (formState.labor === labor._id) {
                        laborsSelected = laborsAvailable[laborsAvailable.length - 1]
                    }
                }
            })
            setLaborsOptions({options: laborsAvailable, selected: laborsSelected})

            machineries?.forEach(machinery => {
                let object = {value: machinery._id, label: machinery.name}
                machineriesAvailable.push(object)
                if(formState.machinery){
                    if (formState.machinery === machinery._id) {
                        machineriesSelected = machineriesAvailable[machineriesAvailable.length - 1]
                    }
                }
            })
            setMachineriesOptions({options: machineriesAvailable, selected: machineriesSelected})

            if(formState.datein){
                setDateinformat(moment(new Date(formState.datein)).format('YYYY-MM-DDTHH:mm'))
            }
            if(formState.dateout){
                setDateoutformat(moment(new Date(formState.dateout)).format('YYYY-MM-DDTHH:mm'))
            }

            setProductsForResume(formState.products)
            setProductsExtraForResume(formState.product_extra)
        }
    // eslint-disable-next-line
    },[formState])

    const plotChange = (target)=>{
        let selectedPlotOption

        plots?.forEach(plot => {
            let object = {value: plot._id, label: plot.name}

            if(plot._id === target.value){
                selectedPlotOption = object
                dispatch(getCropsByPlot(selectedPlotOption.value))
            }
        })
        setPlotsOptions({...plotOptions, selected: selectedPlotOption})
    }

    useEffect(()=>{
        let cropsAvailable = []
        let cropsSelected = null
        crops?.forEach(crop => {
            let object = {value: crop._id, label: crop.name}
            cropsAvailable.push(object)
            if(cropsSelected === null){
                cropsSelected = object
            }
        })
        setCropsOptions({options: cropsAvailable, selected: cropsSelected})
    }, [crops])

    const cropChange = (target)=>{
        let selectedCropOption

        crops?.forEach(crop => {
            let object = {value: crop._id, label: crop.name}

            if(crop._id === target.value){
                selectedCropOption = object
            }
        })
        setCropsOptions({...cropOptions, selected: selectedCropOption})
    }

    useEffect(()=>{
        let laborsAvailable = []
        let laborsSelected = null
        labors?.forEach(labor => {
            let object = {value: labor._id, label: labor.name}
            laborsAvailable.push(object)
            if(laborsSelected === null){
                laborsSelected = object
            }
        })
        setLaborsOptions({options: laborsAvailable, selected: laborsSelected})
    }, [labors])

    const laborChange = (target)=>{
        let selectLaborOptions = []
        let selectedLaborOption

        labors.forEach(labor => {
            let object = {value: labor._id, label: labor.name}
            selectLaborOptions.push(object)

            if(labor._id === target.value){
                selectedLaborOption = object
            }
        })
        setLaborsOptions({options: selectLaborOptions, selected: selectedLaborOption})
    }

    useEffect(()=>{
        let machineriesAvailable = []
        let machineriesSelected = null
        machineries?.forEach(machinery => {
            let object = {value: machinery._id, label: machinery.name}
            machineriesAvailable.push(object)
            if(machineriesSelected === null){
                machineriesSelected = object
            }
        })
        setMachineriesOptions({options: machineriesAvailable, selected: machineriesSelected})
    }, [machineries])

    const machineryChange = (target)=>{
        let selectMachineryOptions = []
        let selectedMachineryOption

        machineries.forEach(machinery => {
            let object = {value: machinery._id, label: machinery.name}
            selectMachineryOptions.push(object)

            if(machinery._id === target.value){
                selectedMachineryOption = object
            }
        })
        setMachineriesOptions({options: selectMachineryOptions, selected: selectedMachineryOption})
    }

    useEffect(() => {
        if(products){
            let selectProductOptions = [{value: 0, label: t('global.select')}]
            // let selectedProductOption

            // let firstItem = 0
            products.forEach(product => {
                if(product.active){
                    let matterAux = t('landingoperator.nomatter')
                    if(product.matter !== undefined){
                        matterAux = product.matter
                    }
    
                    let object = {value: product._id, label: product.name+' ('+ matterAux +')'}
                    selectProductOptions.push(object)

                    // if(firstItem === 0){
                    //     selectedProductOption = object
                    //     firstItem++
                    // }
                }
            })
            setProductsOptions({options: selectProductOptions, selected: {value: 0, label: t('global.select')}})
        }else{
            setProductsOptions({options: null, selected: null})
        }
        //eslint-disable-next-line
    }, [products])

    const productChange = (target)=>{
        let selectProductOptions = [{value: 0, label: t('global.select')}]
        let selectedProductOption

        products.forEach(product => {
            if(product.active){
                let matterAux = t('landingoperator.nomatter')
                if(product.matter !== undefined){
                    matterAux = product.matter
                }

                let object = {value: product._id, label: product.name+' ('+ matterAux +')'}
                selectProductOptions.push(object)

                if(product._id === target.value){
                    selectedProductOption = object
                }
            }
        })
        setProductsOptions({options: selectProductOptions, selected: selectedProductOption})
    }

    const addProduct = (e) =>{
        e.preventDefault()
        let productsUsedState = formState.products
        let valueQuantity = 0

        if(document.getElementById('quantity_product').value !== ''){
            valueQuantity = document.getElementById('quantity_product').value
        }

        productsUsedState.push({
            product: productOptions.selected.value,
            name: productOptions.selected.label,
            type: document.getElementById('type_product').value,
            quantity: parseInt(valueQuantity)
        })

        setFormState({
            ...formState,
            products: productsUsedState
        })

        if(products){
            let selectProductOptions = [{value: 0, label: t('global.select')}]
            let selectedProductOption

            let firstItem = 0
            products.forEach(product => {
                if(product.active){
                    let matterAux = t('landingoperator.nomatter')
                    if(product.matter !== undefined){
                        matterAux = product.matter
                    }
    
                    let object = {value: product._id, label: product.name+' ('+ matterAux +')'}
                    selectProductOptions.push(object)

                    if(firstItem === 0){
                        selectedProductOption = object
                        firstItem++
                    }
                }
            })
            setProductsOptions({options: selectProductOptions, selected: selectedProductOption})
        }else{
            setProductsOptions({options: null, selected: null})
        }

        document.getElementById('quantity_product').value = ''
        document.getElementById('type_product').value = 'Kg'
    }

    const removeProductX = (e, key) =>{
        e.preventDefault()
        let arrayProductsAux = formState.products
        arrayProductsAux.splice(key, 1)

        let arrayProductsAux2 = productsForResume

        setFormState({...formState, products: arrayProductsAux})
        setProductsForResume(arrayProductsAux2)
    }

    const addProductExtra = (e) =>{
        e.preventDefault()
        if(document.getElementById('name_product_extra').value !== ''){
            let productsExtraUsedState = formState.product_extra
            let valueQuantity = 0

            if(document.getElementById('quantity_product_extra').value !== ''){
                valueQuantity = document.getElementById('quantity_product_extra').value
            }

            productsExtraUsedState.push({
                product: document.getElementById('name_product_extra').value,
                type: document.getElementById('type_product_extra').value,
                quantity: parseInt(valueQuantity)
            })

            setFormState({
                ...formState,
                product_extra: productsExtraUsedState
            })

            document.getElementById('name_product_extra').value = ''
            document.getElementById('quantity_product_extra').value = ''
            document.getElementById('type_product_extra').value = 'Kg'
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text: t('landingoperator.productin')
            })
        }
    }

    const removeProductExtraX = (e, key) =>{
        e.preventDefault()
        let arrayProductsAux = formState.product_extra
        arrayProductsAux.splice(key, 1)

        let arrayProductsAux2 = productsExtraForResume

        setFormState({...formState, product_extra: arrayProductsAux})
        setProductsExtraForResume(arrayProductsAux2)
    }

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('cardaux.datein')}</Form.Label>
                    <Form.Control className="form-control"
                        type="datetime-local"
                        name='datein' 
                        value={dateinformat || ''}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                {dateoutformat
                    ?
                        <Form.Group>
                            <Form.Label className="form-label mt-3">{t('cardaux.dateout')}</Form.Label>
                            <Form.Control className="form-control"
                                type="datetime-local"
                                name='dateout' 
                                value={dateoutformat || ''}
                                onChange={inputChange}
                                required
                            />
                        </Form.Group>
                    :
                        <></>
                }
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('cardaux.plot')}</Form.Label>
                    <Select
                        onChange={plotChange}
                        name="plot" 
                        placeholder={t('cardaux.plot')}
                        options={plotOptions.options}
                        value={plotOptions.selected}
                        styles={customStyles}
                        required/>
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('cardaux.crop')}</Form.Label>
                    <Select
                        onChange={cropChange}
                        name="crop" 
                        placeholder={t('cardaux.crop')}
                        options={cropOptions.options}
                        value={cropOptions.selected}
                        styles={customStyles}
                        required/>
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('cardaux.labor')}</Form.Label>
                    <Select
                        onChange={laborChange}
                        name="labor" 
                        placeholder={t('cardaux.labor')}
                        options={laborOptions.options}
                        value={laborOptions.selected}
                        styles={customStyles}
                        required/>
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('cardaux.machinery')}</Form.Label>
                    <Select
                        onChange={machineryChange}
                        name="machinery" 
                        placeholder={t('cardaux.machinery')}
                        options={machineryOptions.options}
                        value={machineryOptions.selected}
                        styles={customStyles}
                        required/>
                </Form.Group>
                <Form.Group><br/>
                    <Form.Label>{t('landingoperator.litres_gasoil')}</Form.Label>
                    <Form.Control 
                        type='number'  
                        name='litres_gasoil'
                        value={formState?.litres_gasoil}
                        onChange={changeLitresGasoil}
                    /><br/>
                    <Form.Label>{t('landingoperator.litres_engine_oil')}</Form.Label>
                    <Form.Control 
                        type='number'  
                        name='litres_engine_oil'
                        value={formState?.litres_engine_oil}
                        onChange={changeLitresEngineOil}
                    /><br/>
                    <Form.Label>{t('landingoperator.litres_hydraulic_oil')}</Form.Label>
                    <Form.Control 
                        type='number'  
                        name='litres_hydraulic_oil'
                        value={formState?.litres_hydraulic_oil}
                        onChange={changeLitresHydraulicOil}
                    /><br/>
                    <Form.Label>{t('landingoperator.litres_urea')}</Form.Label>
                    <Form.Control 
                        type='number'  
                        name='litres_urea'
                        value={formState?.litres_urea}
                        onChange={changeLitresUrea}
                    /><br/>
                    <Form.Label>{t('landingoperator.litres_grease')}</Form.Label>
                    <Form.Control 
                        type='number'  
                        name='litres_grease'
                        value={formState?.litres_grease}
                        onChange={changeLitresGrease}
                    />
                </Form.Group>
                <div id="selectProducts">
                    <hr/>
                    <Form.Label>{t('landingoperator.products')}</Form.Label>
                    <Form.Group>
                        <Select onChange={productChange}
                            id='id_product'
                            placeholder={t('landingoperator.productselect')}
                            options={productOptions.options}
                            value={productOptions.selected}
                            styles={customStyles}
                        />
                    </Form.Group><br/>
                    <div className='row'>
                        <div className='col-6'>
                            <Form.Control 
                                id='quantity_product'
                                type='number'  
                                name='quantity_product'
                                placeholder='0'
                            />
                        </div>
                        <div className='col-6'>
                            <Form.Control
                                as="select"
                                id='type_product'
                                name='type_product'
                                placeholder={t('landingoperator.typeproduct')}
                            >
                                <option value='Kg' defaultValue>{t('products.kg')}</option>
                                <option value='G'>{t('products.g')}</option>
                                <option value='L'>{t('products.l')}</option>
                                <option value='Cl'>{t('products.cl')}</option>
                                <option value='Ml'>{t('products.ml')}</option>
                            </Form.Control>
                        </div>
                        <div className='text-center'>
                            <button onClick={(e) => addProduct(e)} className="mt-4 mb-4 w-50">
                                {t('landingoperator.addproduct')}
                            </button>
                        </div>
                        {
                            productsForResume?.map((product, key) =>(
                                <Fragment key={key}>
                                {console.log(product)}
                                    <Form.Group className="mx-3">
                                        <button className="form-label mx-2 btn btn-primary py-2 px-3" onClick={(e) => removeProductX(e, key)}><i className="fas fa-times"></i></button>
                                        <Form.Label className="form-label mx-2">{product.product?.name ? product.product?.name : product.name }</Form.Label>
                                        <Form.Label className="form-label mx-2">{product.quantity}</Form.Label>
                                        <Form.Label className="form-label mx-2">{product.type}</Form.Label>
                                    </Form.Group><hr/>
                                </Fragment>
                            ))
                        }
                    </div>
                    <FormLabel>{t('landingoperator.product_extra')}</FormLabel>
                    <Form.Control
                        id='name_product_extra'
                        type='text'
                        name='name_product_extra'
                    >
                    </Form.Control><br/>
                    <div className='row'>
                        <div className='col-6'>
                            <Form.Control 
                                id='quantity_product_extra'
                                type='number'
                                name='quantity_product_extra'
                                placeholder='0'
                            />
                        </div>
                        <div className='col-6'>
                            <Form.Control
                                as="select"
                                id='type_product_extra'
                                name='type_product_extra'
                                placeholder={t('landingoperator.productsextra')}
                            >
                                <option value='Kg' defaultValue>{t('products.kg')}</option>
                                <option value='G'>{t('products.g')}</option>
                                <option value='L'>{t('products.l')}</option>
                                <option value='Cl'>{t('products.cl')}</option>
                                <option value='Ml'>{t('products.ml')}</option>
                            </Form.Control>
                        </div>
                        <div className='text-center'>
                            <button onClick={(e) => addProductExtra(e)} className="mt-4 mb-4 w-50">
                                {t('landingoperator.addproductextra')}
                            </button>
                        </div>
                        {
                            productsExtraForResume?.map((product_extra, key) =>{
                                return (
                                    <Fragment key={key}>
                                        <Form.Group className="mx-3">
                                            <button className="form-label mx-2 btn btn-primary py-2 px-3" onClick={(e) => removeProductExtraX(e, key)}><i className="fas fa-times"></i></button>
                                            <Form.Label className="form-label mx-2">{product_extra.product}</Form.Label>
                                            <Form.Label className="form-label mx-2">{product_extra.quantity}</Form.Label>
                                            <Form.Label className="form-label mx-2">{product_extra.type}</Form.Label>
                                        </Form.Group><hr/>
                                    </Fragment>
                                )
                            })
                        }
                    </div>
                </div>
                <Row className="text-left custom-card-header-list">
                    <Button className="btn btn-secondary my-2 mx-auto" type="submit">{t('cardaux.sendchange')}</Button>
                </Row>
            </Form>
        </>
    )    
}
